export var positions = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
};

export var colors = {
  blue: 'blue',
  red: 'red',
  green: 'green'
};
//# sourceMappingURL=ModalConstants.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Modal/ModalConstants.js